import { render, staticRenderFns } from "./display-field-avatar.vue?vue&type=template&id=48f3f018&scoped=true&"
import script from "./display-field-avatar.ts?vue&type=script&lang=ts&"
export * from "./display-field-avatar.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-avatar.scss?vue&type=style&index=0&id=48f3f018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3f018",
  null
  
)

export default component.exports